import {fieldPathJoinGetter} from "../../utils/kp3Utils";

export const entity = {
    name: "Test",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        {path: "description"},
        {path: "pointOfAttention"},
        {path: "axes", type: "Axis", link: "MTM"},
        "Risk",
        "Stakeholder",
        "Control",
        {path: "documents", type: "Document", link: "MTM"},
        fieldPathJoinGetter({
            path: "codeName",
            fieldPath: ["code", "translatedName"],
            joinString: " - "
        })
    ]
}

export const module_ = {
    object: "Test",
    tKey: "mTitle_test",
    category: {
        path: "audit",
        icon: 'bookCheck'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "code"},
            {path: "name", type: "textarea"},
            {path: "axes", tKey: "connectionsToAxes", display: "fullName"},
            {path: "risk", display: "fullName"},
            {path: "stakeholder", display: "fullName"},
            {path: "control", display: "fullName"},
            {path: "description", type: "richTextEditor"},
            {path: "documents", tKey: "requiredDocuments", display: "codeName"},
            {path: "pointOfAttention", type: "richTextEditor"},
        ]
    }
}
